module.exports = __webpack_public_path__ + "img/minus-svgrepo-com.1a415634.svg";